import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinnerDot = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 10,
			fill: "none",
			stroke: "#5AB7DC",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 12,
			fill: "none",
			stroke: "#0B7BC0",
			strokeWidth: 1.25,
			children: /* @__PURE__ */ _jsx("animate", {
				attributeType: "XML",
				attributeName: "r",
				from: 12,
				to: 0,
				dur: "2s",
				repeatCount: "indefinite"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 12,
			fill: "none",
			stroke: "#036",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeType: "XML",
				attributeName: "r",
				from: 12,
				to: 0,
				dur: "3s",
				repeatCount: "indefinite"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 12,
			fill: "none",
			stroke: "#0B7BC0",
			strokeWidth: .25,
			children: /* @__PURE__ */ _jsx("animate", {
				attributeType: "XML",
				attributeName: "r",
				from: 12,
				to: 0,
				dur: "4s",
				repeatCount: "indefinite"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgSpinnerDot);
export { ForwardRef as ReactComponent };
